<template>
  <div class="section-abstract mb-1">
    <v-row class="ma-0 abstract-row" @click="openSection('SectionGestionnairesPaie', 'etablissement', true)">
      <v-col>
        <div class="section-abstract-title" v-if="etablissement.fractionDsn.length <= 0">Configurer vos gestionnaires de
          paie
        </div>
        <div v-else>
          <div class="section-abstract-title">Vos gestionnaires de paie</div>
          <div class="section-abstract-display">Vous avez {{ etablissement.fractionDsn.length }} gestionnaire(s) de paie renseigné(s)</div>
          <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(1, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
          </div>
        </div>
      </v-col>
      <v-col cols="1" style=" align-content: center; align-items: center">
        <v-icon class="arrow-icon" style="font-size: 12px; color: #25A3A7;">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
  </div>
</template>
<script lang="ts">
  import SectionEtablissementGestionnairesAbstract from '@/generated/sections/SectionEtablissementGestionnairesAbstract.vue';
  import { defineAsyncComponent, defineComponent, markRaw, type PropType } from "vue";
  import CrudEtablissement from '@/generated/cruds/CrudEtablissement';
  // eslint-disable-next-line
  import { GenControl, GenSection, RessourceGenControl, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
  import { Fiches, Modules, Sections } from '@/generated/classes/AppSchema';
  import Button, { ButtonCallback } from '@/framework/base/classes/Button';
  import Owner from '@/extend/classes/Owner';
  import Etablissement from '@/extend/classes/Etablissement';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import Route from "@/generated/classes/Route.ts";
  import Section from '@/framework/base/classes/Section';
  import { getSection } from "@/framework/base/helpers/ComponentFinder.ts";

  export default defineComponent({
    extends: SectionEtablissementGestionnairesAbstract,
    components: {},
    methods: {
      headerTitle(): string {
        return "Gestionnaire(s) de paie pour " + this.etablissement.alias;
      },
      openSection(componentName: string, objType: string, isList = false): void {
        if (this.etablissement.fractionDsn.length <= 0) {
          this.setFractionDsn();
        } else {
          const route = new Route();
          const section = new Section();
          const loader = getSection(componentName);
          let component = null;
          if (loader) {
            component = markRaw(defineAsyncComponent(loader as any));
          }
          if (isList) {
            route.module = Modules.ETABLISSEMENT;
            route.fiche = Fiches.CONTAINER;
            route.ficheHeader = this.headerTitle();
            if (component) {
              section.component = component;
            }
            section.propType = objType;
            section.propData = this.etablissement;
            route.data = section;
          }
          this.$emit('openSection', component, route, isList);
        }
      },
      setFractionDsn(): void {
        this.loading = true;
        Etablissement.setFractionDsn(this.refEtablissement).then(() => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
    }
  })
</script>
